import type { CSSProperties } from 'react';

const supportsContentVisibility =
  typeof CSS !== 'undefined' &&
  typeof CSS.supports === 'function' &&
  CSS.supports('content-visibility', 'hidden');

/**
 * Oculta conteúdo preservado sem descartar o estado de renderização.
 * `content-visibility: hidden` mantém o layout em cache para reexibir sem
 * recalcular a árvore inteira; navegadores sem suporte usam `display: none`.
 */
export const getRetainedVisibilityStyle = (active: boolean): CSSProperties => {
  if (active) {
    return supportsContentVisibility ? { contentVisibility: 'visible' } : {};
  }
  return supportsContentVisibility ? { contentVisibility: 'hidden' } : { display: 'none' };
};
